import React, { Component } from "react";
import { Link } from "react-router-dom";
import Constant from "../../Constant";
import { Line, Circle } from "rc-progress";
import Swal from "sweetalert2";

export default class CourseListLearner extends Component {
  state = {
    courses: [],
    trainerOptions: [
      {
        id: 1,
        name: "COURSES",
        // subname: "Add Course",
        icons: <i class="fas fa-book"></i>,
        link: "/learner/course-list",
      },
      // {
      //   id: 2,
      //   name: "GROUPS",
      //   subname: "Add Users",
      //   icons: <i class="fas fa-users"></i>,
      //   link: "/learner/course-list",
      // },
      // {
      //   id: 3,
      //   name: "ASSIGNMENT ",
      //   subname: "No Reports",
      //   icons: <i class="fas fa-check"></i>,
      //   link: "/learner/course-list",
      // },
      {
        id: 4,
        name: "CALENDAR ",
        // subname: "Add Event",
        icons: <i class="fas fa-calendar-alt"></i>,
        link: "/learner/calendar",
      },
      {
        id: 5,
        name: "ACTIVITY LOGS ",
        // subname: "Add Event",
        icons: <i class="fas fa-redo-alt"></i>,
        link: "/activity-logs",
      },
    ],
  };
  componentDidMount() {
    //API will be called here
    this.getCourses();
  }
  getCourses = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteName", localStorage.getItem("lms_site_name"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getSiteAPI() + "/course/getAll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        // var course_data = [];
        // for (let i = 0; i < data.length; i++) {
        //   var obj = {};
        //   obj.name = data[i].name;
        //   obj.image = data[i].image;
        //   obj.id = data[i].id;
        //   if (
        //     data[i].enroll !== null &&
        //     data[i].enroll !== [] &&
        //     data[i].enroll.length > 0
        //   ) {
        //     for (var j = 0; j < data[i].enroll.length; j++) {
        //       if (data[i].enroll[j].id === localStorage.getItem("lms_uid")) {
        //         obj.isEnrolled = true;
        //       } else {
        //         obj.isEnrolled = false;
        //       }
        //     }
        //   }
        //   course_data.push(obj);
        // }
        // console.log("courses : ", course_data);
        // return false;
        this.setState({ courses: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  onSelectedOptions = () => { };
  onChangeCourseListner = () => {
    // filter data from here
  };

  onEnrollUser = (event) => {
    console.log(event.target.id);
    var courseId = event.target.id;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("userId", localStorage.getItem("lms_uid"));
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", courseId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/enroll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // document.location.reload();
        if (result.status === true) {
          if (result.paytmUrl !== undefined && result.paytmUrl !== null && result.paytmUrl !== "") {
            window.open(result.paytmUrl, '_blank');
          } else {
            this.getCourses();
          }
        }
      })
      .catch((error) => console.log("error", error));
  };
  onRemoveEnrollUser = (event) => {
    console.log(event.target.id);
    var courseId = event.target.id;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("userId", localStorage.getItem("lms_uid"));
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", courseId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/unEnroll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // document.location.reload();
        if (result.status === true) {
          this.getCourses();
        }
      })
      .catch((error) => console.log("error", error));
  };
  render() {
    console.log("DATA", this.state.courses);
    return (
      <div className="py-3">
        <div className="container create-course border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/learner/course-list">Home</Link> / <b>Courses</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center"></div>
            </div>
          </div>

          <div className="row m-0">
            <div className="col-md-8 border-right p-0">
              <div class="row m-0 mt-3 ml-2" id="filter">
                <div class="form-group col-sm-4 col-xs-6 m-0">
                  <div class="input-group search-box">
                    <input
                      type="text"
                      id="search"
                      class="form-control"
                      placeholder="Search here"
                      onChange={this.onChangeCourseListner}
                    />
                    <span class="input-group-addon">
                      <i class="material-icons">&#xE8B6;</i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="row p-2 m-0">
                {this.state.courses.map((course) => {
                  return (
                    <div className="col-md-4 my-3" id={course.id}>
                      <div
                        className="card card-selector shadow-sm mt-1 h-100"
                        onClick={this.cardSelect}
                      >
                        {course.isPaid === true
                          ?
                          <span class="ribbon3">Paid</span>
                          :
                          null}
                        {course.courseStatus === "complete" || course.courseStatus === "Complete" || course.courseStatus === "COMPLETE"
                          ?
                          <span class="ribbon1">
                            <span>Completed</span>
                          </span>
                          :
                          null}
                        {course.isEnrolled === true ? (
                          <Link
                            to={`/learner/course/${course.id}`}
                            className="link-unstyled"
                          >
                            <div>
                              <img
                                class="card-img-top course-image"
                                src={
                                  course.image !== ""
                                    ? course.image
                                    : "./images/homepage/placeholder-img.jpg"
                                }
                                alt="course alt"
                                onError={(e) => {
                                  e.target.src = "./images/homepage/placeholder-img.jpg"
                                }}
                              />
                              <div class="card-body text-center p-2">
                                <h6
                                  className="mb-0"
                                  style={{ minHeight: "40px" }}
                                >
                                  {course.name}
                                </h6>
                              </div>
                            </div>
                          </Link>
                        ) : (
                            <div
                              onClick={() => {
                                Swal.fire(
                                  "Error",
                                  "Please Enroll the Course to go furthur",
                                  "warning"
                                );
                              }}
                            >
                              <img
                                class="card-img-top course-image"
                                src={
                                  course.image !== ""
                                    ? course.image
                                    : "./images/homepage/placeholder-img.jpg"
                                }
                                alt="course alt"
                              />
                              <div class="card-body text-center p-2">
                                <h6
                                  className="mb-0"
                                  style={{ minHeight: "40px" }}
                                >
                                  {course.name}
                                </h6>
                              </div>
                            </div>
                          )}
                        {/* {course.isEnrolled === true ?
                          <Link
                            to={`/certificates/${course.id}`}
                            className="btn btn-warning shadow-sm mx-1"
                          > DownLoad Certificate
                          </Link>
                          :
                          null} */}
                        {course.isEnrolled === true && course.isPaid !== true || course.isEnrolled === true && (course.courseStatus === "complete" || course.courseStatus === "Complete" || course.courseStatus === "COMPLETE") ? (
                          <button
                            class="btn btn-danger shadow-sm mx-1"
                            id={course.id}
                            onClick={this.onRemoveEnrollUser}
                          >
                            Remove
                          </button>
                        ) : (
                            <button
                              class="btn shadow-sm mx-1 btn-primary"
                              id={course.id}
                              onClick={this.onEnrollUser}
                            >
                              Enroll
                            </button>
                          )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-md-4 right-section pl-0">
              {this.state.trainerOptions.map((option) => (
                <div
                  onClick={this.onSelectedOptions.bind(this, option.id)}
                  className={`card card-selector shadow-sm p-2 m-2 ${
                    option.id == this.state.selectedOption ? "selected" : ""
                    }`}
                >
                  <div className="row">
                    <div className="col-2">
                      <div className="icon d-flex justify-content-center align-items-center shadow-sm border">
                        {option.icons}
                      </div>
                    </div>
                    <div className="col-10">
                      <div className="text d-flex flex-column">
                        <Link to={option.link}  className="p-2">
                          {" "}
                          <h5 className="m-0 btn-link">{option.name}</h5>{" "}
                        </Link>
                        {/* <p className="m-0">{option.subname}</p> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
